import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { accessNested, joinClasses } from 'utils/utils';
import { findInVNode } from 'utils/vnode';
import { Howl, Howler } from 'howler';
import { Audio } from 'helpers/quizIcons';
import { quizCopy } from 'helpers/quizCopy';
import Store from 'store/store';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	constructor(props) {
		super(props);
		this.registerInteraction = this.registerInteraction.bind(this);
		this.quizToggleSound = this.quizToggleSound.bind(this);
		this.playSound = this.playSound.bind(this);
		this.state = {
			...this.state,
			firstInteractionRegistered: false
		};
	}

	componentDidMount() {
		super.componentDidMount();
		const quizData = this.props?.appData?.pages?.admissionsQuiz?.data;
		if (!quizData) return;
		const scrollAudio = quizData?.audio?.scroll || '';
		const revealAudio = quizData?.audio?.reveal || '';
		this.scrollAudio = new Howl({
			src: scrollAudio
		});
		this.revealAudio = new Howl({
			src: revealAudio
		});
		Howler.mute(true);
		Store.on('QUIZ_PLAY_SOUND', this.playSound);
		document.addEventListener('click', this.registerInteraction);
		if (this.props?.client?.isIOS) {
			document.addEventListener('touchstart', this.registerInteraction);
		}
	}

	componentWillUnmount() {
		Store.off('QUIZ_PLAY_SOUND', this.playSound);
		document.removeEventListener('click', this.registerInteraction);
		if (this.props?.client?.isIOS) {
			document.removeEventListener('touchstart', this.registerInteraction);
		}
	}

	registerInteraction(e) {
		if (this.state.firstInteractionRegistered) return;
		this.firstTouchTime = e.timeStamp;
		this.quizToggleSound();
		this.setState({
			firstInteractionRegistered: true
		});
	}

	playSound(sound) {
		if (!this.state.firstInteractionRegistered) return;
		this[sound].play();
	}

	quizToggleSound(e) {
		if (e && this.firstTouchTime) {
			if (e.timeStamp - this.firstTouchTime < 500) {
				this.firstTouchTime = null;
				return;
			} else {
				this.firstTouchTime = null;
			}
		}
		const { soundOn } = this.props?.admissionsQuiz || {};
		Howler.mute(soundOn);
		Store.emit('QUIZ_TOGGLE_SOUND', !soundOn);
	}

	async toggleShare() {
		const sharePopoutOpen = accessNested(this.props, 'headerData.shareOpen', false);
		const webShareEnabled = accessNested(this.props, 'appData.header.powsterHeader.share.webShare', false);
		const device = this.props?.client?.device || '';
		const isMobile = device !== 'desktop' && device !== 'tablet';
		const isAdmissionsQuiz = this.props?.activePage === 'admissionsQuiz';

		if (!sharePopoutOpen && webShareEnabled && isMobile && navigator.share) {
			Store.emit('CLICKED_MOBILE_NATIVE_SHARE');
			const title = accessNested(this.props, 'appData.copy.baseCopy.$META_TITLE', '');
			const url = window.location.href;
			const text = isAdmissionsQuiz ? quizCopy.$socialShareCopy : accessNested(this.props, 'appData.copy.baseCopy.$SOCIAL_COPY', '');

			try {
				await navigator.share({ text, title, url });
			} catch (err) {
				console.log('Share failed:', err.message);
			}
			return;
		}

		Store.emit('TOGGLE_SHARE_OPEN');

		if (!sharePopoutOpen) {
			Store.emit('ENABLE_SCROLLING_LOCK');
			return;
		}
		Store.emit('DISABLE_SCROLLING_LOCK');
	}

	renderPersistentButton() {
		const base = super.renderPersistentButton();
		return (
			<div class={s.persistentBtnContainer}>
				{base}
			</div>
		);
	}

	renderShare() {
		const base = super.renderShare();
		if (this.props.activePage !== 'admissionsQuiz') return base;

		const sharePopout = findInVNode(base, '[key="share"]');
		if (sharePopout) {
			sharePopout.attributes = {
				...sharePopout.attributes,
				shareCopy: quizCopy.$socialShareCopy
			};
		}
		return base;
	}

	render(props) {
		const base = super.render(props);
		if (props.activePage === 'admissionsQuiz') {
			const quizData = props?.admissionsQuiz || {};
			const audioContainer = (
				<button class={joinClasses(s.audioButton, !quizData.soundOn && s.muted)} onClick={this.quizToggleSound}>
					<Audio />
				</button>
			);
			base.children.push(audioContainer);
		}
		return base;
	}

}
